<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  created() {
    this.handleSpotIdSave();
    this.getUser();
  },
  methods: {
    ...mapMutations(['setSpotId', 'setParkId']),
    ...mapActions(['getUser']),
    handleSpotIdSave() {
      if (!window.sessionStorage.getItem('spotId')) {
        try {
          const spotId = window.location.search
            .split('&')
            .map(item => item.split('='))
            .find(([key]) => key.includes('spot_id'))[1];
          window.sessionStorage.setItem('spotId', spotId);
        } catch {
          window.sessionStorage.setItem('spotId', 0);
        }
      }

      if (window.location.search.search('park_id') > 0) {
        const parkId = window.location.search
          .split('&')
          .map(item => item.split('='))
          .find(([key]) => key.includes('park_id'))[1];
        window.sessionStorage.setItem('parkId', parkId);
      }

      const spotId = window.sessionStorage.getItem('spotId');
      this.setSpotId(spotId);
      if (spotId === '0') {
        this.$router.replace('/spots_list');
      } else if (!window.location.href.indexOf('ticket_check')) {
        this.$router.replace(`/spots_detail/${spotId}`);
      }
    },
  },
};
</script>

<style lang="less">
::-webkit-scrollbar {
  display: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
}
</style>
